import { Alert, Box, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';

export function NoAccessPage() {
  return (
    <Box sx={{ p: 4, maxWidth: 560 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        No access assigned
      </Typography>
      <Alert severity="info">
        Your account is active, but an administrator has not given you access yet.
        You will see the tabs and actions for your roles once they are assigned.
      </Alert>
      {/* RBAC Phase 4: an eligible-only role holds nothing until it is activated. */}
      <Button component={RouterLink} to="/my-access" sx={{ mt: 2 }}>
        Activate an eligible role in My access
      </Button>
    </Box>
  );
}
